import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useFormState } from 'react-final-form';
import { FormSimpleSelect } from '../../../../../../components/atoms/Fields/Select/templates/SimpleSelect';
import { FormCheckbox } from '../../../../../../components/atoms/Fields/Checkbox';
import { useFeesProfileData } from '../../OrderForm/hooks';
import { OrderFormValues } from '../../../types';
import { WizardStep, REQUIRED_FIELD_HINTS } from '../consts';
import ReviewSummary from './ReviewSummary';
import {
  StyledStepGrid,
  StyledStepCard,
  StyledStepCardTitle,
  StyledMissingBanner,
  StyledMissingChip,
} from '../styles';

interface StepDeliveryReviewProps {
  isEdit?: boolean;
  onJump: (step: WizardStep) => void;
}

const StepDeliveryReview: React.FC<StepDeliveryReviewProps> = ({ onJump }) => {
  const intl = useIntl();
  const { values } = useFormState<OrderFormValues>();
  const { deliveryChargeOptions } = useFeesProfileData();

  // Non-blocking heads-up only — submission is never prevented client-side.
  const missing = REQUIRED_FIELD_HINTS.filter(
    ({ field }) => !values[field as keyof OrderFormValues]
  );

  return (
    <StyledStepGrid>
      <StyledStepCard>
        <StyledStepCardTitle>
          <FormattedMessage
            id='orderWizard.review.delivery'
            defaultMessage='Delivery'
          />
        </StyledStepCardTitle>
        {missing.length > 0 && (
          <StyledMissingBanner role='status'>
            <FormattedMessage
              id='orderWizard.missingInfo'
              defaultMessage='Usually required and still empty:'
            />
            {missing.map(({ field, labelId, defaultLabel, step }) => (
              <StyledMissingChip
                key={field}
                type='button'
                onClick={() => onJump(step)}
              >
                {intl.formatMessage({
                  id: labelId,
                  defaultMessage: defaultLabel,
                })}
              </StyledMissingChip>
            ))}
          </StyledMissingBanner>
        )}
        <FormSimpleSelect
          disabled={!values.city}
          name='deliveryRegion'
          label={intl.formatMessage({
            id: 'delivery.deliveryCharge',
            defaultMessage: 'Delivery charge',
          })}
          options={deliveryChargeOptions}
        />
        <FormCheckbox
          name='amountIncludeDeliveryCharge'
          label={intl.formatMessage({
            id: 'forms.fields.amountIncludeDeliveryCharge',
            defaultMessage: 'Include Delivery Charge',
          })}
        />
      </StyledStepCard>
      <StyledStepCard>
        <StyledStepCardTitle>
          <FormattedMessage
            id='orderWizard.review.title'
            defaultMessage='Review'
          />
        </StyledStepCardTitle>
        <ReviewSummary />
      </StyledStepCard>
    </StyledStepGrid>
  );
};

export default StepDeliveryReview;
